import StatsTemplate from "./StatsTemplate";

export default function StatsApps() {
  return <StatsTemplate entityLabel="Apps" entityType="apps" />;
}